import {useEffect, useState} from 'react';

const ANIMATION_DURATION = 350;
const ANIMATION_DELAY = 100;

const FIRST_ELEMENT_DELAY = ANIMATION_DURATION + ANIMATION_DELAY;
const SECOND_ELEMENT_DELAY = ANIMATION_DURATION * 2 + ANIMATION_DELAY * 2;

export function useTransitionElements({
  isSectionVisible,
  isFormSubmitted,
}: {
  isSectionVisible: boolean;
  isFormSubmitted: boolean;
}) {
  const [showInstructions, setShowInstructions] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const [showExplanation, setShowExplanation] = useState(false);

  /*
    There are three scenarios the animiations accoun for:
    - Channel is chosen
    1. Animate in the instructions after the channel bubbles have finished
      animating out plus a small delay
    2. Animate in the form after the instructions have finished plus a small delay

    - Form is submitted
    1. Immediately hide the form
    2. Wait a bit for the form to dissapear and the top bar to appear (RAC-only) and then
      animate in the summary bubble
    3. Animate in the explanation message after the summary bubble has finished plus a small delay

    - Form is cancelled
    1. Immediately hide the instructions and the form
  */

  // Instructions message
  useEffect(() => {
    if (isSectionVisible && !isFormSubmitted) {
      setTimeout(() => {
        setShowInstructions(true);
      }, FIRST_ELEMENT_DELAY);
    } else if (isSectionVisible && isFormSubmitted) {
      setShowInstructions(true);
    } else {
      setShowInstructions(false);
    }
  }, [isSectionVisible, isFormSubmitted]);

  // Inline form
  useEffect(() => {
    if (isSectionVisible && !isFormSubmitted) {
      setTimeout(() => {
        setShowForm(true);
      }, SECOND_ELEMENT_DELAY);
    } else {
      setShowForm(false);
    }
  }, [isSectionVisible, isFormSubmitted]);

  // Summary user bubble
  useEffect(() => {
    if (isSectionVisible && isFormSubmitted) {
      setTimeout(() => {
        setShowSummary(true);
      }, FIRST_ELEMENT_DELAY);
    }
  }, [isSectionVisible, isFormSubmitted]);

  // Explanation message
  useEffect(() => {
    if (isSectionVisible && isFormSubmitted) {
      setTimeout(() => {
        setShowExplanation(true);
      }, SECOND_ELEMENT_DELAY);
    }
  }, [isSectionVisible, isFormSubmitted]);

  return {
    showInstructions,
    showForm,
    showSummary,
    showExplanation,
    setShowInstructions,
    setShowForm,
  };
}
